import { render, staticRenderFns } from "./ShiftsOverview.vue?vue&type=template&id=19ab8928&scoped=true&"
import script from "./ShiftsOverview.vue?vue&type=script&lang=js&"
export * from "./ShiftsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsOverview.vue?vue&type=style&index=0&id=19ab8928&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab8928",
  null
  
)

export default component.exports